
<template>
   <v-layout row wrap>
      <v-flex xs12>
         <v-card>
            <v-toolbar color="brown lighten-2" dark>
               <v-toolbar-title>Aliments favoris</v-toolbar-title>
            </v-toolbar>
            <v-list>
               <template v-for="(favorite, index) in favorites">
                  <v-list-tile avatar :key="favorite.id" @click.stop="addFavorite(favorite)">
                     <v-list-tile-avatar>
                        <v-btn icon large ripple v-if="favorite.portion_pict">
                           <img :src="pictPath(favorite.portion_pict)">
                        </v-btn>
                     </v-list-tile-avatar>
                     <v-list-tile-content>
                        <v-list-tile-title>{{ favorite.food_name }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ favoritePortionDescription(favorite) }}</v-list-tile-sub-title>
                     </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-if="index + 1 < favorites.length" :key="favorite.id + '-'"></v-divider>
               </template>
            </v-list>

            <v-card-text v-if="favorites.length === 0" style="height: 80px;" class="Aligner">
               <v-icon>not_interested</v-icon>
            </v-card-text>
         </v-card>
      </v-flex>
   </v-layout>
</template>


<script>
   import _ from 'lodash'

   export default {

      props: {
         userId: Number,
         index: Number,
      },

      computed: {
         favorites() {
            if (this.$store.state.meals.user2index2favorites[this.userId] &&
                  this.$store.state.meals.user2index2favorites[this.userId][this.index]) {
               let favoriteIds = this.$store.state.meals.user2index2favorites[this.userId][this.index]
               let favorites = favoriteIds.map(favoriteId => this.$store.state.meals.favorites[favoriteId])
               return _.orderBy(favorites, ['count'], ['desc'])
            } else {
               return []
            }
         },
      },

      methods: {
         pictPath(pict) {
            return `/static/media/${pict}`
         },
         favoritePortionDescription(favorite) {
            if (favorite.nbportion === '1.00') {
               return favorite.portion_name
            } else if (favorite.nbportion === '0.25') {
               return "\u00BC x " + favorite.portion_name
            } else if (favorite.nbportion === '0.50') {
               return "\u00BD x " + favorite.portion_name
            } else if (favorite.nbportion === '0.75') {
               return "\u00BE x " + favorite.portion_name
            } else {
               let nbPortionStr = parseFloat(favorite.nbportion).toLocaleString('fr-FR', { maximumFractionDigits: 2 })
               return `${nbPortionStr} x ${favorite.portion_name}`
            }
         },
         addFavorite(favorite) {
            this.$emit('addFavorite', favorite)
         },
      },

   }
</script>




// WEBPACK FOOTER //
// Favorites.vue?07c83505